<div class="modal-header">
  <h4 class="modal-title pull-left">Modifica modello {{ name }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<form [formGroup]="updateModelForm" (ngSubmit)="onUpdateModelSubmit()">
  <div class="modal-body">
    <div *ngIf="errorMessage" class="alert alert-danger my-3">
      {{ errorMessage }}
    </div>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">Modello</span>
        </div>
        <input
          type="text"
          formControlName="nome"
          placeholder="Nome del modello"
          class="form-control"
          [class.is-invalid]="
            modelSubmitted && getModelFormControls.nome.errors
          "
          (ngModelChange)="didUserEdit = true"
        />
        <div
          *ngIf="modelSubmitted && getModelFormControls.nome.errors"
          class="invalid-feedback"
        >
          <div *ngIf="getModelFormControls.nome.errors.required">
            La nome è un campo obbligatorio
          </div>
          <div *ngIf="getModelFormControls.nome.errors.minlength">
            Nome troppo corta
          </div>
          <div *ngIf="getModelFormControls.nome.errors.maxlength">
            Nome troppo lunga
          </div>
        </div>
      </div>
    </div>
    <mat-form-field style="width: 100%">
      <mat-label>Marca</mat-label>
      <input
        type="text"
        placeholder="Scegli"
        aria-label="marca"
        matInput
        formControlName="marca"
        [matAutocomplete]="auto"
        (ngModelChange)="didUserEdit = true"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option
          *ngFor="let option of brandsFilteredOptions | async"
          [value]="option?.vehicleModels.vbr_name"
        >
          {{ option.vehicleModels.vbr_name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-slide-toggle
      color="primary"
      (change)="activeChecked = !activeChecked; didUserEdit = true"
      [checked]="activeChecked"
    >
      Attivo
    </mat-slide-toggle>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" [disabled]="!didUserEdit || isLoading">
      <span
        *ngIf="isLoading"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      Effettua modifiche
    </button>
  </div>
</form>
